import { distance } from "../lib/distance"

export function useAttackPlayer(
  object,
  {
    player,
    damage = 1,
    attackPoint = { x: 0, y: 0 },
    attackRadius = 10,
    attackCooldown = 1000,
  },
) {
  object.lastAttack = Date.now()
  object.attackCooldown = attackCooldown

  return () => {
    const now = Date.now()
    if (now - object.lastAttack < object.attackCooldown) return

    const apx = object.x + (attackPoint.x || 0) * object.width
    const apy = object.y + (attackPoint.y || 0) * object.height

    const totalRadius = attackRadius + 20 // Add some radius for the player body

    if (
      // Quicker distance check first
      (Math.abs(apx - player.x) < 2 * totalRadius ||
        Math.abs(apy - player.y) < 2 * totalRadius) &&
      // Proper distance check
      distance(apx, apy, player.x, player.y) <= totalRadius
    ) {
      player.health = Math.max(player.health - damage, 0)
      player.lastHit = now
      object.lastAttack = now
    }
  }
}
